import React from 'react'
import { l } from '@manychat/manyui'

import NextStepSelectItem from 'common/builder/components/builder/NextStepSelectItem'
import {
  NextStepTypeColors,
  NextStepTypeIcons,
  NextStepTypeNames,
} from 'common/builder/models/Source/constants'
import { ISmartLinkNextTypeOption } from 'components/MCTextEditor/interfaces/smartLinkNextTypeOption'

const SmartLinkTypePicker = ({
  options,
  onSelect,
  hasCtaButton,
  label = l.translate('When This Link is Clicked'),
}: {
  options: ISmartLinkNextTypeOption[]
  onSelect: (type: string) => void
  label?: string
  hasCtaButton?: boolean
}) => {
  const getTooltip = (option: ISmartLinkNextTypeOption) => {
    if (option.disabled) {
      return option.tooltip
    } else if (hasCtaButton) {
      return l.translate(
        'It’s not possible to add inline link because you already added Open Website button. Remove Open Website button from the message first.',
      )
    } else {
      return ''
    }
  }

  return (
    <div style={{ width: '275px' }}>
      <h3 className="m-b-md m-y">{label}</h3>
      {options.map((option: ISmartLinkNextTypeOption) => {
        return (
          <NextStepSelectItem
            key={option.type}
            type={option.type}
            onSelect={() => onSelect(option.type)}
            icon={NextStepTypeIcons[option.type]}
            color={NextStepTypeColors[option.type]}
            title={l.getString(NextStepTypeNames[option.type])}
            disabled={option.disabled || hasCtaButton}
            tooltip={getTooltip(option)}
            data-test-id={NextStepTypeIcons[option.type]}
          />
        )
      })}
    </div>
  )
}
export default SmartLinkTypePicker
